<div class="dialog-frame" id="iplexDeviceStartDialogFrame">
  <ng-container *ngIf="isConfirmedGuidanceMessage; else guidanceMessage">
    <h2 mat-dialog-title>{{ "iplexDeviceStartConnectDialogComponent.dialogTitle" | translate }}</h2>
    <div class="container">
      <p class="connexion-confirmation">
        {{ "iplexDeviceStartConnectDialogComponent.message1" | translate }}<br />
        {{ "iplexDeviceStartConnectDialogComponent.message2" | translate }}
      </p>

      <div class="form-div" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
        <mat-form-field fxFlex>
          <mat-label>{{ "iplexDeviceStartConnectDialogComponent.deviceNamePlaceholder" | translate }}</mat-label>
          <input matInput [maxlength]="clientNameMaxLength" [formControl]="clientNameControl" required />
          <mat-hint align="end">{{ clientNameControl.value?.length || 0 }}/ {{ clientNameMaxLength }}</mat-hint>
          <mat-error *ngIf="clientNameControl.invalid && clientNameControl.hasError('required')">
            {{ "iplexDeviceStartConnectDialogComponent.clientNameRequiredError" | translate }}
          </mat-error>
          <mat-error *ngIf="clientNameControl.invalid && clientNameControl.hasError('maxlength')">
            {{ "iplexDeviceStartConnectDialogComponent.clientNameMaxlengthError" | translate: { maxLength: clientNameMaxLength } }}
          </mat-error>
          <mat-error *ngIf="clientNameControl.hasError('pattern') && !clientNameControl.hasError('required')">
            {{ "iplexDeviceStartConnectDialogComponent.clientNameRegexError" | translate }}
          </mat-error>
        </mat-form-field>
      </div>
    </div>

    <div class="container" fxLayout="row" fxLayoutAlign="center center" position="fixed">
      <mat-dialog-actions>
        <button mat-button mat-dialog-close color="primary">{{ "iplexDeviceStartConnectDialogComponent.cancel" | translate }}</button>
        <button mat-raised-button [disabled]="clientNameControl.invalid" color="primary" (click)="connect()">
          {{ "iplexDeviceStartConnectDialogComponent.connect" | translate }}
        </button>
      </mat-dialog-actions>
    </div>
  </ng-container>
</div>

<ng-template #guidanceMessage>
  <h2 mat-dialog-title>{{ "iplexDeviceStartConnectDialogComponent.guidanceMessageTitle" | translate }}</h2>

  <mat-dialog-content class="mat-typography guidance-message-content">
    <p>{{ "iplexDeviceStartConnectDialogComponent.guidanceMessage1" | translate }}</p>
    <p>{{ "iplexDeviceStartConnectDialogComponent.guidanceMessage2" | translate }}</p>
  </mat-dialog-content>

  <mat-dialog-actions align="center">
    <button mat-button mat-dialog-close color="primary">{{ "iplexDeviceStartConnectDialogComponent.cancel" | translate }}</button>
    <button mat-button color="primary" (click)="confirmGuidanceMessage()">{{ "iplexDeviceStartConnectDialogComponent.next" | translate }}</button>
  </mat-dialog-actions>
</ng-template>
